/*
 * founder — IO entrance reveal + deferred click-to-play for the founder film.
 * Reveal: adds .founder--in when the section enters view (CSS fades media + staggers
 * eyebrow → quote → attribution). Play: clicking the play overlay injects the deferred
 * <video> (preload=none) and plays it, then fades the poster + button out (.is-playing).
 * Reduced-motion / no-IO → reveal immediately; <noscript> reveals for no-JS.
 */
(function () {
  var roots = document.querySelectorAll('[data-founder]');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window);

  roots.forEach(function (root) {
    /* entrance reveal */
    if (reduce) {
      root.classList.add('founder--in');
    } else {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { root.classList.add('founder--in'); obs.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    /* deferred video play */
    var media = root.querySelector('[data-founder-media]');
    if (!media) return;
    var btn = media.querySelector('[data-founder-play]');
    var tpl = media.querySelector('[data-founder-tpl]');
    if (!btn || !tpl) return;
    btn.addEventListener('click', function () {
      if (media.classList.contains('is-playing')) return;
      media.appendChild(tpl.content.cloneNode(true));
      media.classList.add('is-playing');
      var vid = media.querySelector('video');
      if (vid) { try { vid.play(); } catch (e) {} }
    });
  });
})();
